var _ = require('underscore');
var TorsoView = require('backbone-torso/modules/View');
var eregStaffPatientAppointmentDetailsTemplate = require('./eregStaffPatientAppointmentDetailsTemplate.hbs');
var DemographicsDataBehavior = require('./../../demographics/DemographicsDataBehavior');
var SecureMessageDataBehavior = require('./../../secure-message/SecureMessageDataBehavior');
var AppointmentTypeParentBehavior = require('./../../behaviors/AppointmentTypeParentBehavior');
var AppointmentTypeDataBehavior = require('./../../appointment-type/AppointmentTypeDataBehavior');

/**
 * View for staff facing patient appointment details
 *
 * @class EregStaffPatientAppointmentDetailsView
 * @extend Torso.View
 */
module.exports = TorsoView.extend({
  moduleNamespace: 'eregStaffPatientAppointmentDetailsView',
  template: eregStaffPatientAppointmentDetailsTemplate,
  tagName: 'section',
  className: 'brec-content-block brec-content-block--highlighted brec-content-block--compact-vertical',

  behaviors: {
    demographics: {
      behavior: DemographicsDataBehavior,
      returnSingleResult: true,
      renderOnFetch: true,
      id: { property: '_patientVecnaId' }
    },
    appointment: {
      behavior: SecureMessageDataBehavior,
      renderOnFetch: true,
      ids: function(cache) {
        var appointmentExternalIds = this.view._appointmentExternalIds;
        if (!appointmentExternalIds) {
          return { skipObjectRetrieval: true };
        }

        var patientVecnaId = this.view._patientVecnaId;
        var criteria = cache.getCriteriaForAppointmentIdAndExternalId(patientVecnaId, appointmentExternalIds);
        return cache.fetchIdsByCriteria(criteria);
      }
    },
    appointmentTypeParentBehavior: {
      behavior: AppointmentTypeParentBehavior,
      renderOnParentFetched: true
    },
    appointmentType: {
      behavior: AppointmentTypeDataBehavior,
      renderOnFetch: true,
      ids: { property : 'behaviors.appointment.data:appointmentDTO.externalAppointment.type' }
    },
    parentAppointmentType: {
      behavior: AppointmentTypeDataBehavior,
      renderOnFetch: true,
      ids: { property: 'behaviors.appointmentType.data:parentExternalId' }
    }
  },

  prepareFields: {
    appointmentLinesData: function() {
      var thisView = this;
      var appointmentModels = this.getBehavior('appointment').data.getModels();
      var appointmentTypeBehavior = this.getAppointmentTypeBehavior();
      return _.map(appointmentModels, function(appointmentModel) {
        var appointmentTime = appointmentModel.get('appointmentDTO.externalAppointment.time');
        var appointmentTypeId = appointmentModel.get('appointmentDTO.externalAppointment.type');
        var appointmentTypeModel = appointmentTypeBehavior.data.getModel(appointmentTypeId);
        var serviceLevelAppointmentType = thisView.getServiceLevelAppointmentType(appointmentTypeId);
        var visitLevelAppointmentTypeDisplayName = appointmentTypeModel && appointmentTypeModel.get('displayName');
        var serviceLevelAppointmentTypeDisplayName = serviceLevelAppointmentType && serviceLevelAppointmentType.get('displayName');
        if (visitLevelAppointmentTypeDisplayName === serviceLevelAppointmentTypeDisplayName) {
          serviceLevelAppointmentTypeDisplayName = null;
        }
        return {
          time: appointmentTime,
          visitLevelAppointmentTypeDisplayName: visitLevelAppointmentTypeDisplayName,
          serviceLevelAppointmentTypeDisplayName: serviceLevelAppointmentTypeDisplayName
        };
      });
    }
  },

  /**
   * @method initialize
   * @override
   * @param options {Object} Options to configure this view.
   *   @param [options.patientVecnaId] {String} Patient vecna id
   *   @param [options.appointmentExternalIds] {String} Appointment external id
   */
  initialize: function(options) {
    this._patientVecnaId = options.patientVecnaId;
    this._appointmentExternalIds = options.appointmentExternalIds;
  }
});
